function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M227.7 483.2l-34.6 34.6 242.5 242.5L990 206l-34.6-34.6-519.8 519.7-207.9-207.9zm656.6-63c5 25.8 7.7 52.5 7.7 79.8 0 230-186.5 416.5-416.5 416.5S59 730 59 500 245.5 83.5 475.5 83.5c118.6 0 225.6 49.6 301.4 129.1l34.7-34.7c-84.7-88.4-204-143.4-336.1-143.4C218.4 34.5 10 242.9 10 500s208.4 465.5 465.5 465.5S941 757.1 941 500c0-41.7-5.5-82.2-15.8-120.7l-40.9 40.9z"
});

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    stroke: "#2FCE67",
    fill: "#2FCE67",
    viewBox: "0 0 1000 1000"
  }, props), _ref);
}

export default __webpack_public_path__ + "eadabe1b1cf5071a97c01786ebdbad89.svg";
export { SvgSuccess as ReactComponent };